import type { SVGProps } from 'react';
export const Page = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1rem" height="1rem" fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path
      fillRule="evenodd"
      d="M6.3 4.35v11.3h7.4v-7.6h-2.4a.6.6 0 0 1-.46-.2.7.7 0 0 1-.19-.48V4.35zm5.66 1.16.97 1.18h-.97zM5.28 3.39c.2-.23.48-.39.8-.39h5.22q.31 0 .5.24l3.04 3.68q.16.2.16.45v8.43c0 .28-.1.58-.28.8q-.31.38-.8.4H6.08c-.33 0-.61-.16-.8-.4-.2-.22-.29-.52-.29-.8V4.2c0-.28.1-.58.28-.8"
      clipRule="evenodd"
    />
  </svg>
);
